import React from "react";
// import './PrivacyPolicy.css'
import { Link } from "react-router-dom";
import privacyPolicyBanner from '../assets/bannerImages/privacyPolicyBanner.jpg'

export default function PrivacyPolicy(){
    return(
        <div className="privacyPolicy">
            <PPR1/>
            <PPR2/>
            <PPR3/>
            <ContactSection/>
        </div>
    )
}

function PPR1(){
    return(
        <div className="ppr1">
            <h1 className="title">Privacy Policy</h1>
                <div className="overlay"/>
            <img loading="lazy" src={privacyPolicyBanner} alt="r1-img" className="r1-img"/>
        </div>
    )
}

function PPR2(){
    return(
        <div className="ppr2">
            <h1>Privacy Policy</h1>
        </div>
    )
}

function PPR3(){
    let listOne = [
        "Personal Information: We may collect personal information such as your name, email address, phone number, and company name when you voluntarily provide it to us through contact forms or other interactive features on our website.",
        "Usage Information: We collect non-personal information related to your use of our website, including IP addresses, browser type, operating system, and browsing behavior. This information is used to improve the performance and functionality of our website."
    ]
    let listTwo = [
        "To respond to your inquiries and provide you with information or services you request.",
        "To personalize your experience on our website and improve its content.",
        "To analyze website usage and trends to enhance our website's functionality.",
        "To send you relevant updates, newsletters, or promotional materials if you have opted to receive them.",
        "To comply with legal obligations and protect our rights."
    ]
    let listThree = [
        "Access the personal information we hold about you.",
        "Correct any inaccuracies in your personal information.",
        "Request the deletion of your personal information, subject to legal requirements.",
        "Opt-out of receiving promotional communications from us."
    ]
    return(
        <div className="ppr3">
            <div className="content">
                <div className="rowOne row">
                    <h4 className="heading">Information We Collect</h4>
                    <p className="para">When you visit our website, we may collect the following types of information:</p><br/>
                    <ul className="list">
                        {
                            listOne.map((item, index)=>(
                                <li key={item}>{index + 1}. {item}</li>
                            ))
                        }
                    </ul>
                </div><br/><br/>

                <div className="rowTwo row">
                    <h4 className="heading">How We Use Your Information</h4>
                    <p className="para">We may use the information we collect for the following purposes:</p><br/>
                    <ul className="list">
                        {
                            listTwo.map((item, index)=>(
                                <li key={item}>{index + 1}. {item}</li>
                            ))
                        }
                    </ul>
                </div><br/><br/>

                <div className="rowThree row">
                    <h4 className="heading">Data Security</h4>
                    <p className="para">We take data security seriously and implement appropriate measures to safeguard your information. However, please be aware that no method of online data transmission is entirely secure. While we strive to protect your personal information, we cannot guarantee its absolute security.</p>
                </div><br/><br/>

                <div className="rowFour row">
                    <h4 className="heading">Third-Party Links</h4>
                    <p className="para">Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We recommend reviewing the privacy policies of those websites before providing any personal information.</p>
                </div><br/><br/>

                <div className="rowFive row">
                    <h4 className="heading">Your Choices</h4>
                    <p className="para">You have the right to:</p><br/>
                    <ul className="list">
                        {
                            listThree.map((item, index)=>(
                                <li key={item}>{index + 1}. {item}</li>
                            ))
                        }
                    </ul>
                </div><br/><br/>

                <div className="rowFive row">
                    <h4 className="heading">Changes to This Privacy Policy</h4>
                    <p className="para">We may update this Privacy Policy periodically to reflect changes in our data practices or legal requirements. We encourage you to review this policy whenever you visit our website to stay informed about how we protect your information.</p>
                </div><br/><br/>

                <div className="rowFive row">
                    <h4 className="heading">Contact Us</h4>
                    <p className="para">If you have any questions, concerns, or requests regarding our Privacy Policy or the handling of your personal information, please contact us.</p>
                    <p className="para">By using our website, you consent to the practices described in this Privacy Policy.</p>
                </div><br/><br/>

            </div>
        </div>
    )
}

function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss With Us?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}